import type { RootState } from '@core/core/store'

import { markerNamesByFieldAdapter } from '././markerNamesByFieldsSlice'

const { selectAll } = markerNamesByFieldAdapter.getSelectors<RootState>(
  state => state.hotStorage.markerNamesByFields,
)

export const selectHotStorageFieldsWithMarkers = selectAll
